import { Flex, Text, IconButton, Divider } from '@components';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { FormattedMessage } from 'react-intl';
import { InactiveContainer } from './UltimateBeneficialOwnerForm.styles';
import { useTheme } from '@mui/material';
import { UltimateBeneficialOwner } from '@features/api/response/UltimateBeneficialOwner';

export interface UltimateBeneficialOwnerSummaryProps {
  ultimateBeneficialOwner: Partial<UltimateBeneficialOwner>;
  handleEditClick: () => void;
  handleRemoveClick: () => void;
}

const UltimateBeneficialOwnerSummary: React.FC<UltimateBeneficialOwnerSummaryProps> =
  ({ ultimateBeneficialOwner, handleEditClick, handleRemoveClick }) => {
    const theme = useTheme();

    return (
      <InactiveContainer>
        <Flex sx={{ gap: theme.spacing(8) }}>
          <Flex>
            <Text
              variant='h5'
              fontWeight='fontWeightBold'
            >{`${ultimateBeneficialOwner?.firstName} ${ultimateBeneficialOwner?.middleName} ${ultimateBeneficialOwner?.lastName}`}</Text>
          </Flex>
          <Flex gap={3}>
            <IconButton
              onClick={handleEditClick}
              size='small'
              iconBoxHeight={12}
              iconBoxWidth={16}
              data-testid='ubo-edit-icon'
              icon={() => (
                <EditIcon
                  fontSize='small'
                  sx={{ color: theme.palette.success.main }}
                />
              )}
            />
            <IconButton
              onClick={handleRemoveClick}
              size='small'
              iconBoxHeight={12}
              iconBoxWidth={16}
              data-testid='ubo-delete-icon'
              icon={() => (
                <DeleteOutlineIcon
                  fontSize='small'
                  sx={{ color: theme.palette.error.main }}
                />
              )}
            />
          </Flex>
        </Flex>
        <Divider />
        <Flex flexDirection='column'>
          <Flex gap={3}>
            <Text variant='h6' fontWeight='fontWeightSemiBold'>
              <FormattedMessage id='investment.ubo.email' />:
            </Text>
            <Text variant='h6' fontWeight='fontWeightRegular'>
              {ultimateBeneficialOwner?.email}
            </Text>
          </Flex>
          <Flex gap={3}>
            <Text variant='h6' fontWeight='fontWeightSemiBold'>
              <FormattedMessage id='investment.ubo.ownershipPercentage' />:
            </Text>
            <Text variant='h6' fontWeight='fontWeightRegular'>
              {ultimateBeneficialOwner?.ownershipPercentage}%
            </Text>
          </Flex>
        </Flex>
      </InactiveContainer>
    );
  };

export default UltimateBeneficialOwnerSummary;
